import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { registerUser } from '../../react-cognito';
import { NotificationManager } from 'react-notifications';
import store from '../../store'
import { Loader } from '../loader';
import PhoneInput from 'react-phone-number-input';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AvatarEditor from 'react-avatar-editor';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import "react-phone-number-input/style.css";


import { createUser } from '../../actions/user';
const $ = window.$;
const initialState={
  country:'',
  currentFormNotValid: false,
  first_name: '',
  last_name: '',
  emp_id: '',
  username: '',
  contact: '',
  gender: 'Male',
  password: '',
  birthday: moment().toDate(),
  role: 'Admin',
  loading: false,
  imgSrc: '',
  imgName: '',
  zoom: 1.5,
  editor: '',
  rotate: 0,
};
let formdata = {};
class Datamodal extends React.Component {
  constructor(props) {
    super(props);
  }

  state = initialState;

  submitUser = (event) => {
    event.preventDefault()
    const userPool = this.props.userPool;
    const config = this.props.config;
    this.setState({loading:true})
    if (this.validateForm()) {
      let data = Object.values(formdata).map(key => {
        if (key !== null) {
          return true;
        }
        else {
          return false;
        }
      });

      if (!data.includes(false)) {
        registerUser(userPool, config, this.state.username, this.state.password, {}).then(
          (action) => {
    
            store.dispatch(action);
            if (this.props.cognitoState === 'CONFIRMATION_REQUIRED') {
              this.setState({ loading: false })
              NotificationManager.info("Please Confirm your account");
              // history.push('/confirm');
            }
    
            if (this.props.cognitoState === 'USER_REGISTERED') {
              formdata.user_sub = this.props.userSub;
              formdata.congnito_id = this.props.userSub;
              formdata.username = this.props.createdUser.username;
              this.props.createUser(formdata);
            }
          },
          error => {
            this.setState({ loading: false })
            if(error === 'User already exists')
              error = "This username has already registered with Petpos. Please try a different username"
            NotificationManager.error(error);
          });
      }
      else {
        this.setState({ currentFormNotValid: true });
        this.setState({ loading: false });
        NotificationManager.warning("Please check input details again.");
      }
    }
    
  }
  validateForm(){
    const regXmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var image = '';
    if(this.state.editor && this.state.imgSrc) {
        image = this.state.editor.getImageScaledToCanvas().toDataURL("image/jpeg");
    }
    const data = {
      avatar: image,
      avatar_title: this.state.imgName,
      firstname: this.state.first_name.trim().length > 0 ? this.state.first_name:null,
      lastname: this.state.last_name.trim().length > 0 ? this.state.last_name:null,
      employee_id: this.state.emp_id.toString().trim().length > 0 ? this.state.emp_id:null,
      username:  this.state.username.toString().trim().length > 0 ? this.state.username:null,
      contact_no: this.state.contact.toString().trim().length > 0 ?this.state.contact:null,
      password:this.state.password.toString().trim().length > 0 ? this.state.password:null,
      role: this.state.role,
      gender: this.state.gender,
      birthday: moment(this.state.birthday).isValid() ? moment(this.state.birthday).format('YYYY-MM-DD'):null,
      PetShopId: this.props.petShop.currentPetshop.id,
    }
    formdata = Object.assign({},data);
    return true;
  }
  changeVal = (event) => {
    this.setState({[event.target.name]: event.target.value})
  }

  changeDate = (value) => {
    this.setState({ 'birthday': value })
  }

  resetState = () => {
    this.setState(initialState);
  }

  setEditorRef = (editor) => {
    if(editor) {
      this.setState({editor: editor});
    }
  }

  changeZoom = (val) => {
    if(val) {
        this.setState({zoom: val})
    }
  }

  changeRotate = () => {
    var nr = parseInt(this.state.rotate) + 90;
    if(nr >= 360) nr = 0;
    this.setState({rotate: nr});
  }

  _onChange = () =>{
    // Assuming only image
    var file = this.refs.file.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
  
     reader.onloadend = function (e) {
        this.setState({
            imgSrc: reader.result,
            imgName: file.name
        })
      }.bind(this);
    // TODO: concat files
  }
  componentDidMount = () => {
    this.setState({country:this.props.petShop.currentPetshop.country})
}

  componentWillReceiveProps = (nextProps) => {
    if(this.props.newUser !== nextProps.newUser && nextProps.newUser) {
      if(nextProps.newUser) {
        $('#new_user').modal('hide');
        this.resetState();
        if(nextProps.newUser.msg)
          NotificationManager.error(nextProps.newUser.msg);
        else
          NotificationManager.success("User created successfully");
      }
    }
  }

  render() {
    const {country,first_name, last_name, emp_id, username, contact, password, role, gender, birthday} = this.state;

    return (
      <div className="modal fade show" id="new_user" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            
              <form onSubmit={this.submitUser} className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">New User</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  
                    <div className="row">
                      <div className="col-xl-8 offset-xl-2">
                        <div className="m-form__section m-form__section--first">
                          <div className="m-form__heading">
                            <h3 className="m-form__heading-title">Upload Avatar</h3>
                          </div>
                          {this.state.imgSrc && 
                            <div className="form-group m-form__group row justify-content-md-center m--align-center">
                                <div className="col-xs-10 col-md-4 offset-md-2">
                                    <div className="row">
                                      <div className="col-xs-12 col-sm-12">
                                        <AvatarEditor
                                            ref={this.setEditorRef}
                                            image={this.state.imgSrc}
                                            border={0}
                                            width={200}
                                            height={200}
                                            borderRadius={100}
                                            color={[0, 0, 0, 0.6]} // RGBA
                                            scale={this.state.zoom}
                                            rotate={this.state.rotate}
                                        />
                                      </div>
                                    </div>
                                    <div className="row justify-content-md-center m--align-center">
                                      <div className="col-xs-12 col-sm-12">
                                        <button type="button" className="btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--pill" onClick={this.changeRotate}>
                                          <i className="la la-rotate-right"></i>
                                        </button>
                                      </div>
                                    </div>
                                </div>
                                <div className="col-xs-2 col-md-4 d-none d-sm-none d-md-block">
                                    <div className='slider orientation-reversed'>
                                        <div className='slider-group'>
                                            <div className='slider-vertical'>
                                                <Slider
                                                    min={1}
                                                    max={5}
                                                    step={0.1}
                                                    tooltip={false}
                                                    value={this.state.zoom}
                                                    orientation='vertical'
                                                    onChange={this.changeZoom}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-2 col-md-4 d-block d-sm-block d-md-none d-lg-none">
                                    {/* <div className='slider orientation-reversed'>
                                        <div className='slider-group'>
                                            <div className='slider-vertical'> */}
                                            <Slider
                                                min={1}
                                                max={5}
                                                step={0.1}
                                                tooltip={false}
                                                value={this.state.zoom}
                                                onChange={this.changeZoom}
                                            />
                                            {/* </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                          }
                          <div className="form-group m-form__group row">
                              <label className="col-lg-4 col-form-label">Upload Image</label>
                              <div className="col-lg-8">
                                  <input 
                                      ref="file"
                                      type="file"
                                      accept="image/*" 
                                      name="imgSrc"
                                      onChange={this._onChange}/>
                              </div>
                          </div>
                          <div className="m-separator m-separator--dashed m-separator--lg"></div>
                          <div className="m-form__heading">
                            <h3 className="m-form__heading-title">User Details</h3>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* First Name:</label>
                            <div className="col-xl-9 col-lg-9">
                              <input type="text" name="first_name" onChange={this.changeVal} className="form-control m-input" placeholder="" value={first_name}/>
                              <span className={formdata.firstname===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter first name</span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* Last Name:</label>
                            <div className="col-xl-9 col-lg-9">
                              <input type="text" name="last_name" onChange={this.changeVal} className="form-control m-input" placeholder="" value={last_name}/>
                              <span className={formdata.lastname===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter last name</span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* Employment Id:</label>
                            <div className="col-xl-9 col-lg-9">
                              <input type="text" name="emp_id" onChange={this.changeVal} className="form-control m-input" placeholder="" value={emp_id}/>
                              <span className={formdata.employee_id===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter employment id</span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* Birthday:</label>
                            <div className="col-xl-9 col-lg-9">
                              <DatePicker
                                selected={birthday} 
                                value={birthday} 
                                onChange={ this.changeDate } 
                                onSelect={ this.changeDate }
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                              />
                              {/* <div className="input-group date" id="m_datepicker_2">
                                <input type="text" name="birthday" onSelect={this.changeVal} value={birthday} className="form-control m-input" placeholder="Select date"/>
                                <span className="input-group-addon">
                                  <i className="la la-calendar-check-o"></i>
                                </span>
                              </div> */}
                              <span className={formdata.birthday===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter birthday</span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* Gender:</label>
                            <div className="col-xl-9 col-lg-9">
                              <select className="form-control m-input" onChange={this.changeVal} name="gender" value={gender} id="genderSelect">
                                <option>Male</option>
                                <option>Female</option>
                              </select>
                              <span className='m-form__help'>Please select gender</span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* Contact No:</label>
                            <div className="col-xl-9 col-lg-9">
                              <PhoneInput
                                country={country}
                                className="form-control"
                                placeholder="Enter phone number"
                                value={ contact }
                                onChange={ value => this.setState({ 'contact': value }) }/>
                              <span className={formdata.contact_no===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter contact no</span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* Username:</label>
                            <div className="col-xl-9 col-lg-9">
                              <input name="username" onChange={this.changeVal} className="form-control m-input" placeholder="" value={username}/>
                              <span className={formdata.username===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter username</span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* Password:</label>
                            <div className="col-xl-9 col-lg-9">
                              <input type="password" name="password" onChange={this.changeVal} className="form-control m-input" placeholder="" value={password}/>
                              <span className={formdata.password===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter password</span>
                            </div>
                          </div>
                          <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">* Role:</label>
                            <div className="col-xl-9 col-lg-9">
                              <select className="form-control m-input" onChange={this.changeVal} name="role" value={role} id="roleSelect">
                                <option value="Admin">Admin</option>
                                <option value="Caretaker">Caretaker</option>
                                <option value="Cashier">Cashier</option>
                                <option value="Copywriter">Copywriter</option>
                                <option value="SalesPerson">SalesPerson</option>
                                <option value="Inspector">Inspector</option>
                              </select>
                              <span className='m-form__help'>Please select role</span>
                            </div>
                          </div>
                        </div>	            
                      </div>
                    </div>
                </div>
                <div className="modal-footer">
                  {this.state.loading == false ?
                    <div>
                      <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Close</button>
                      <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                    </div>
                    :
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  }
                </div>
              </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  userPool: state.cognito.userPool,
  config: state.cognito.config,
  cognitoState: state.cognito.state,
  petShop: state.petShopReducer,
  newUser: state.userReducer.newUser,
  userSub: state.cognito.userSub,
  createdUser: state.cognito.newUser
});

const mapDispatchToProps = dispatch => ({
  createUser: (user) => {
    dispatch(createUser(user));
  }
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Datamodal));
